"use client";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import SvgLogout from "./common-header-icons/SvgLogout";
import MenuLink from "./menu/MenuLink";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useLang } from "@/providers/langProvider";
import { useLogout } from "@/hooks/useLogout";

interface Props {
  mobile?: boolean;
}

const Logout: React.FC<Props> = ({ mobile = false }) => {
  const t = useTranslation();
  const { logout } = useLogout();
  const { push } = useRouter();
  const lang = useLang();
  return (
    <div style={mobile ? { marginTop: 64 } : {}}>
      <MenuLink
        isMobile={mobile}
        onClick={() => {
          logout();
          push("/" + lang + "/");
        }}
        title={{ Svg: <SvgLogout />, text: t.logout }}
      />
    </div>
  );
};

export default Logout;
